
<br>
<div class="wrapper mt-4 mb-5">
    <div class="row logo-container">
        <img src="./assets/icons/logo-btf.svg">
    </div>
    <div class="row component saldo">
        <div class="col-12">
            <app-saldo></app-saldo>
        </div>
    </div>

    <div class="row component acesso-rapido">
        <div class="col-12">
            <app-acesso-rapido *ngIf="autorizar" [progresso]="progresso"></app-acesso-rapido>
        </div>
    </div>
    <!-- [CCS 20240904]: Removed doacoes/donnations component to make it work
    <div class="row component doacoes">
        <div class="col-12">
            <app-doacoes></app-doacoes>
        </div>
    </div>
    -->
    <div class="row component pedidos">
        <div class="col-12">
            <app-ultimos-pedidos></app-ultimos-pedidos>
        </div>
    </div>

    <div class="row chart component">
        <div class="col-12">
            <app-chart></app-chart>
        </div>
    </div>
</div>
